import TagAndPillsContainer from "../../components/uiKits/tagAndPills";

const TagAndPills = () => {
  return <TagAndPillsContainer />;
};

export default TagAndPills;
